declare const BUILD_INFO: any;
export const BuildInfo = BUILD_INFO;

// export const productName = "psychlab";

export const companyName = "ENVALYS";

export const companyLogo = "/envralys.svg";

export const companyURL = "https://envalys.is/";